import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/la2.png'
import _imports_1 from '@/assets/registerlogo.png'


const _withScopeId = n => (_pushScopeId("data-v-a67719e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "login" }
const _hoisted_3 = { class: "login-left" }
const _hoisted_4 = { class: "title-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "知了云校园开放平台", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "banner"
  })
], -1))
const _hoisted_7 = {
  class: "login",
  style: {"height":"582px"}
}
const _hoisted_8 = { class: "login-left" }
const _hoisted_9 = { class: "title-container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "知了云校园开放平台", -1))
const _hoisted_11 = { class: "get-code" }
const _hoisted_12 = { class: "mb-2 flex items-center text-sm" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "",
    class: "banner",
    style: {"height":"76%"}
  })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createElementVNode("p", null, "©2023 鹤山市骏升科技有限公司 粤ICP备2022060041号 PowerBY iCampus团队")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_collapse_transition = _resolveComponent("el-collapse-transition")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_tabs, {
        modelValue: _ctx.activeName,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.activeName) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_collapse_transition, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "登录",
                name: "first"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_el_image, {
                          style: {"width":"100px","height":"100px"},
                          src: _ctx.logo,
                          fit: "cover"
                        }, null, 8, ["src"]),
                        _hoisted_5
                      ]),
                      _createVNode(_component_el_form, {
                        model: _ctx.form,
                        "label-width": "70px",
                        "label-position": "top",
                        size: "large",
                        rules: _ctx.rules,
                        ref: "formRef"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { prop: "phone" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.form.phone,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.phone) = $event)),
                                clearable: "",
                                placeholder: "请输入手机号"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { prop: "password" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.form.password,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
                                type: "password",
                                clearable: "",
                                placeholder: "请输入密码",
                                "show-password": ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_divider),
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "success",
                                onClick: _ctx.submit,
                                loading: _ctx.isLoading,
                                class: "login-btn"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("登录")
                                ]),
                                _: 1
                              }, 8, ["onClick", "loading"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model", "rules"])
                    ]),
                    _hoisted_6
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_collapse_transition, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "注册",
                name: "second"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_el_image, {
                          style: {"width":"100px","height":"100px"},
                          src: _ctx.logo,
                          fit: "cover"
                        }, null, 8, ["src"]),
                        _hoisted_10
                      ]),
                      _createVNode(_component_el_form, {
                        model: _ctx.registerform,
                        "label-width": "120px",
                        size: "large",
                        rules: _ctx.rules1,
                        ref: "formRef1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            prop: "phone",
                            label: "手机号",
                            "label-width": _ctx.formLabelWidth
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.registerform.phone,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.registerform.phone) = $event)),
                                clearable: "",
                                placeholder: "请输入手机号"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label-width"]),
                          _createVNode(_component_el_form_item, {
                            prop: "code",
                            label: "验证码",
                            "label-width": _ctx.formLabelWidth
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.registerform.code,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.registerform.code) = $event)),
                                clearable: "",
                                placeholder: "请输入验证码"
                              }, {
                                append: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_11, [
                                    _withDirectives(_createVNode(_component_el_button, {
                                      onClick: _ctx.countDown,
                                      style: {"background-color":"rgba(231, 161, 57)","border-radius":"51px"},
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("获取验证码")
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]), [
                                      [_vShow, !_ctx.countDownIng]
                                    ]),
                                    _withDirectives(_createElementVNode("span", null, "倒计时" + _toDisplayString(_ctx.countDownTime), 513), [
                                      [_vShow, _ctx.countDownIng]
                                    ])
                                  ])
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label-width"]),
                          _createVNode(_component_el_form_item, {
                            prop: "password",
                            label: "密码",
                            "label-width": _ctx.formLabelWidth
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.registerform.password,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.registerform.password) = $event)),
                                clearable: "",
                                placeholder: "请输入密码",
                                "show-password": "",
                                type: "password"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label-width"]),
                          _createVNode(_component_el_form_item, {
                            prop: "allpassword",
                            label: "再次输入密码",
                            "label-width": _ctx.formLabelWidth
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.registerform.allpassword,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.registerform.allpassword) = $event)),
                                clearable: "",
                                placeholder: "请再次输入密码",
                                "show-password": "",
                                type: "password"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label-width"]),
                          _createVNode(_component_el_form_item, {
                            label: "选择用户类型",
                            "label-width": _ctx.formLabelWidth,
                            prop: "ty"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_el_radio_group, {
                                  modelValue: _ctx.registerform.ty,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.registerform.ty) = $event)),
                                  size: "small",
                                  class: "ml-4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_radio, { label: "1" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("服务商")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_radio, { label: "2" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("合作伙伴")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_radio, { label: "3" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("学校")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_radio, { label: "4" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("平台")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ])
                            ]),
                            _: 1
                          }, 8, ["label-width"]),
                          _createVNode(_component_el_divider),
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "success",
                                class: "login-btn",
                                onClick: _ctx.registerbtn,
                                style: {"background-color":"rgba(13, 90, 243)"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("注册")
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model", "rules"])
                    ]),
                    _hoisted_13
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _hoisted_14
  ], 64))
}